import { render, staticRenderFns } from "./tp-order-record.vue?vue&type=template&id=78d5f432&scoped=true&"
import script from "./tp-order-record.vue?vue&type=script&lang=js&"
export * from "./tp-order-record.vue?vue&type=script&lang=js&"
import style0 from "./tp-order-record.vue?vue&type=style&index=0&id=78d5f432&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5f432",
  null
  
)

export default component.exports